import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/auth/signup')({
  head: () => ({
    meta: [{ title: 'Create account — Goaltree' }],
  }),
  beforeLoad: () => {
    throw redirect({ to: '/auth/login', replace: true })
  },
  component: () => null,
})
